/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ZoneAssetMapAssetResponseDto
 */
export interface ZoneAssetMapAssetResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ZoneAssetMapAssetResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneAssetMapAssetResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneAssetMapAssetResponseDto
     */
    assetTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneAssetMapAssetResponseDto
     */
    assetModelName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZoneAssetMapAssetResponseDto
     */
    zoneName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ZoneAssetMapAssetResponseDto
     */
    installedAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ZoneAssetMapAssetResponseDto
     */
    openIncidentsCount: number;
}

/**
 * Check if a given object implements the ZoneAssetMapAssetResponseDto interface.
 */
export function instanceOfZoneAssetMapAssetResponseDto(value: object): value is ZoneAssetMapAssetResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('assetTypeName' in value) || value['assetTypeName'] === undefined) return false;
    if (!('assetModelName' in value) || value['assetModelName'] === undefined) return false;
    if (!('zoneName' in value) || value['zoneName'] === undefined) return false;
    if (!('installedAt' in value) || value['installedAt'] === undefined) return false;
    if (!('openIncidentsCount' in value) || value['openIncidentsCount'] === undefined) return false;
    return true;
}

export function ZoneAssetMapAssetResponseDtoFromJSON(json: any): ZoneAssetMapAssetResponseDto {
    return ZoneAssetMapAssetResponseDtoFromJSONTyped(json, false);
}

export function ZoneAssetMapAssetResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZoneAssetMapAssetResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetName': json['assetName'],
        'assetTypeName': json['assetTypeName'],
        'assetModelName': json['assetModelName'],
        'zoneName': json['zoneName'],
        'installedAt': (json['installedAt'] == null ? null : new Date(json['installedAt'])),
        'openIncidentsCount': json['openIncidentsCount'],
    };
}

export function ZoneAssetMapAssetResponseDtoToJSON(json: any): ZoneAssetMapAssetResponseDto {
    return ZoneAssetMapAssetResponseDtoToJSONTyped(json, false);
}

export function ZoneAssetMapAssetResponseDtoToJSONTyped(value?: ZoneAssetMapAssetResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetName': value['assetName'],
        'assetTypeName': value['assetTypeName'],
        'assetModelName': value['assetModelName'],
        'zoneName': value['zoneName'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'openIncidentsCount': value['openIncidentsCount'],
    };
}

